/* import __COLOCATED_TEMPLATE__ from './course-progress-list.hbs'; */
import Component from '@glimmer/component';
import type UserModel from 'codecrafters-frontend/models/user';
import type CourseParticipationModel from 'codecrafters-frontend/models/course-participation';
import groupByFieldReducer from 'codecrafters-frontend/utils/group-by-field-reducer';

interface Signature {
  Element: HTMLDivElement;

  Args: {
    user: UserModel;
  };
}

export default class CourseProgressList extends Component<Signature> {
  get courseParticipationGroups() {
    const participationsGroupedByCourse: CourseParticipationModel[][] = Object.values(
      this.args.user.courseParticipations
        .filter(
          (participation) =>
            !participation.course.releaseStatusIsDeprecated &&
            !participation.course.visibilityIsPrivate &&
            !participation.course.releaseStatusIsAlpha,
        )
        .reduce(
          groupByFieldReducer((participation) => participation.course.id),
          {},
        ),
    );

    const sortedParticipationsGroupedByCourse = participationsGroupedByCourse.map((group) =>
      group.sort((a, b) => new Date(a.lastSubmissionAt).getTime() - new Date(b.lastSubmissionAt).getTime()),
    );

    sortedParticipationsGroupedByCourse.sort((groupA: CourseParticipationModel[], groupB: CourseParticipationModel[]) => {
      const groupAHasCompleted = groupA.some((participation) => participation.isCompleted);
      const groupBHasCompleted = groupB.some((participation) => participation.isCompleted);

      if (groupAHasCompleted && !groupBHasCompleted) {
        return -1;
      } else if (!groupAHasCompleted && groupBHasCompleted) {
        return 1;
      } else {
        // If both groups have completed participations or both don't, sort by the lastSubmissionAt of the last participation in the group
        const lastSubmissionA = new Date(groupA[groupA.length - 1]!.lastSubmissionAt);
        const lastSubmissionB = new Date(groupB[groupB.length - 1]!.lastSubmissionAt);

        return lastSubmissionA.getTime() - lastSubmissionB.getTime();
      }
    });

    return sortedParticipationsGroupedByCourse;
  }
}
